/* unplugin-vue-components disabled */import { render } from "./Col1.vue.js?vue&type=template&id=af63ea75!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Col1.vue?vue&type=template&id=af63ea75"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__